// Lightweight CSV export helper. No dependencies.
// columns: [{ key, label, value? }]  rows: array of objects
// `value(row)` overrides how a cell is derived; otherwise row[key] is used.

function escapeCell(val) {
  if (val == null) return "";
  const s = String(val);
  // Quote if the value contains comma, quote, or newline; double up quotes.
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function exportCsv(filename, columns, rows) {
  const header = columns.map((c) => escapeCell(c.label)).join(",");
  const body = rows
    .map((row) =>
      columns
        .map((c) => escapeCell(c.value ? c.value(row) : row[c.key]))
        .join(",")
    )
    .join("\r\n");

  // Prepend BOM so Excel opens UTF-8 (Tamil names etc.) correctly.
  const csv = "﻿" + header + "\r\n" + body;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
